/**
 * rest 请求配置
 */

export default {
  dsn: 'https://8b06083928ce4c40a756866f6eb405f5@sentry.lixinio.com/13',
  release: process.env.PROJECT_VERSION,
  logger: 'javascript',
  blacklistUrls: [/sentry\.lixinio\.com/, /hm\.baidu'.com/, /map\.qq\.com/],
  environment: process.env.RUN_ENV,
  ignoreErrors: [/^Can't find variable: WeixinJSBridge$/, /^WeixinJSBridge is not defined$/]
}
